import { render, staticRenderFns } from "./IRPF.vue?vue&type=template&id=f9177636&scoped=true&"
import script from "./IRPF.vue?vue&type=script&lang=js&"
export * from "./IRPF.vue?vue&type=script&lang=js&"
import style0 from "./IRPF.vue?vue&type=style&index=0&id=f9177636&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9177636",
  null
  
)

export default component.exports